import { render, staticRenderFns } from "./SubMGM.vue?vue&type=template&id=b120fa2e&scoped=true"
import script from "./SubMGM.vue?vue&type=script&lang=js"
export * from "./SubMGM.vue?vue&type=script&lang=js"
import style0 from "./SubMGM.vue?vue&type=style&index=0&id=b120fa2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b120fa2e",
  null
  
)

export default component.exports